<div class="flex items-center mx-2 lg:mr-8">
    <a (click)="ckeckModifica()" href="https://www.comune.sanlazzaro.bo.it/" target="_blank">
        <img class="dark:hidden md:w-26 sm:w-15 h-auto rounded-full" src="assets/images/sanlazzaro/sanlazzaro.png"
            alt="Logo Comune di San Lazzaro di Savena">
    </a>

    <a class="mx-2" href="https://www.comune.sanlazzaro.bo.it/" target="_blank">
        <div class="font-semibold md:text-4xl sm:text-xl">Comune di San Lazzaro di Savena</div>
    </a>
</div>
